import React from 'react';
import { FeedbackForm } from './FeedbackForm/FeedbackForm';

const Feedback = () => {
  return <FeedbackForm />;
};

export { Feedback };
